import React from "react";

function Icon({ className = "w-6 h-6" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M10.793 9.958v2.748a2.392 2.392 0 00-3 2.216 2.163 2.163 0 002.312 2.3 2.156 2.156 0 002.311-2.326V4h2.719c.463 2.876 1.9 3.544 3.827 3.852v2.756a8.19 8.19 0 01-3.75-1.266v5.445C15.21 17.25 13.75 20 10.125 20a5.11 5.11 0 01-5.085-5.239 5.01 5.01 0 015.753-4.803z"
      />
    </svg>
  );
}

export default Icon;
